export default "__VITE_ASSET__B1WCd2AB__"